
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/live/popup",
      function () {
        return require("private-next-pages/live/popup.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/live/popup"])
      });
    }
  